import { reduce } from 'lodash'

import { formatDescriptorOriginField } from '../utils'

const computeTextDescriptorHighlights = (prefix, value) =>
  reduce(
    value,
    (acc, descriptor, index) => {
      const parsedDescriptor = JSON.parse(descriptor)

      return {
        ...acc,
        [formatDescriptorOriginField(prefix, index)]: parsedDescriptor.text,
      }
    },
    {},
  )

export default computeTextDescriptorHighlights
